// extracted by mini-css-extract-plugin
export default {"confirmBlocker":"confirm-blocker_confirmBlocker__ytfc1","button":"confirm-blocker_button__Jv98G","confirmButton":"confirm-blocker_confirmButton__m+IW3"};